import { LocaleUtils } from '@wyz/utils';
import i18n from 'i18next';
import HttpBackend, { HttpBackendOptions } from 'i18next-http-backend';

import { initReactI18next } from 'react-i18next';
import { log } from '~/common/helpers';
import { Domain, IGlobalConfig } from '~/common/types';

export const init = (
  locale: string = LocaleUtils.DEFAULT_LOCALE,
  config: IGlobalConfig,
) =>
  i18n
    .use(HttpBackend)
    .use(initReactI18next)
    .init<HttpBackendOptions>({
      lng: locale,
      fallbackLng: LocaleUtils.DEFAULT_LOCALE,
      preload: [LocaleUtils.DEFAULT_LOCALE],
      partialBundledLanguages: true,
      ns: ['messages'] as Array<Domain>,
      resources: {},
      interpolation: {
        escapeValue: false,
      },
      backend: {
        crossDomain: false,
        reloadInterval: false,
        loadPath: (languages) => {
          const language = languages[0];
          return `/translations/${config.i18nConfig[language] || config.i18nConfig[LocaleUtils.DEFAULT_LOCALE]}`;
        },
        addPath: (language) => {
          return `/translations/${config.i18nConfig[language] || config.i18nConfig[LocaleUtils.DEFAULT_LOCALE]}`;
        },
      },
      react: {
        useSuspense: true,
      },
    })
    .catch((error: Error) => {
      log(error);
    });
export const getInstance = () => {
  return i18n;
};
